import {isPositive} from 'ramda-adjunct';

/** The grid cell holds 0 when a record has no unread messages; the card shows nothing then. */
export const getUnreadMessageCount = (value: unknown) =>
  typeof value === 'number' && isPositive(value) ? value : null;
